import type { DirectiveBinding } from 'vue'
export default function (el: HTMLElement, binding: DirectiveBinding) {
  nextTick(() => {
    const topValue = el.getBoundingClientRect().top
    const bottomValue = binding.value?.bottom || 20 // 表格底部默认20的距离
    el.style.height = `calc(100vh - ${topValue}px - ${bottomValue}px - 10px)` // 10px 页面底部
  })
}
